import { Customizations } from 'models'
import useGetCurrentCustomization from './useGetCurrentCustomization'

const useGetCurrentOrder = () => {
  const { currentCustomization } = useGetCurrentCustomization()
  const order = Object.keys(currentCustomization) as Array<keyof Customizations>
  return { order }
}

export default useGetCurrentOrder
